import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductStack } from './ProductStack';
import { CHECKOUT_URL } from '../data/product';
const included = ['6 volumes · 300 landscape pages', '59 Ready-Run Sessions for kids, teens & rec groups', '29 printable worksheets, trackers & planners', '16 named coaching frameworks', '5 bonuses, incl. the 30-Day Quick-Start Roadmap', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-ice text-ink" data-id="element-148" data-mp="1ru166g7t24cv">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-149" data-mp="25tsogt5cu6wo">
        <div className="text-center" data-id="element-150" data-mp="20slfiqrh71of">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-151" data-mp="20rjxg2c1lex7">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-152" data-mp="3c8a6rubrimv1">
            A full year of parkour classes, ready to run
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-navy-line bg-navy-card shadow-card" data-id="element-153" data-mp="4s49x6ox4jfs">
          <div className="bg-gold px-5 py-5 text-center" data-id="element-154" data-mp="9tjvr0yx6tz8">
            <h3 className="font-display text-xl uppercase tracking-wide text-gold-ink sm:text-2xl" data-id="element-155" data-mp="er1vq1uylyv3">
              The Parkour Class-Ready Megapack
            </h3>
            <p className="mt-1 text-[13px] font-bold uppercase tracking-widest text-gold-ink/75" data-id="element-156" data-mp="3dasavd29jfq9">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-157" data-mp="3n63rk0x8ex0n">
            <div className="overflow-hidden rounded-2xl bg-navy-deep px-4 py-6 sm:px-8 sm:py-8" data-id="element-158" data-mp="3n52570armo3m">
              <ProductStack className="max-w-[380px]" lazy data-id="element-159" data-mp="3rzy7ct9purug" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-160" data-mp="2uhy61byct3zr">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-161" data-mp="2zfzl7lsnsj5y">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-162" data-mp="2rftf2huvdvit">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-163" data-mp="2mhi4u60nxj02" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-ice-dark pt-6 text-center" data-id="element-164" data-mp="2w83agder7nsh">
              <p className="text-[13px] text-ink-soft" data-id="element-165" data-mp="28j1wkan5jkft">
                Total value <span className="text-ink-muted line-through" data-id="element-166" data-mp="23j5tcdma3x1b">$97 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-167" data-mp="2ifwuosfijitk">
                <span className="mt-2.5 font-display text-3xl" data-id="element-168" data-mp="2ie3mh8p94qjg">$</span>
                <span className="font-display text-[56px] leading-[0.9] sm:text-7xl" data-id="element-169" data-mp="2dgady90h7kg0">27</span>
                <span className="mt-3 text-[13px] font-bold text-ink-muted" data-id="element-170" data-mp="3tu0ljpqt0que">USD</span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-171" data-mp="3ovqrjigtfwad">
                <span className="rounded border border-gold bg-gold px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-gold-ink" data-id="element-172" data-mp="a42rp0cwqnv">
                  Save $70
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-173" data-mp="3nfv2s6hoa3ns">
                  One-time payment
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-174" data-mp="j0limt03brrt">
                  Lifetime access
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-175" data-mp="a7i5ymx9riy8">
                Get the Megapack — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-176" data-mp="e825ty9890o2">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-177" data-mp="16q7jrm00wh2g">
                <li className="flex items-center gap-1.5" data-id="element-178" data-mp="3f7s9rt6mzzso">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-179" data-mp="3f55vlap8qm1h" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-180" data-mp="358kpem1hj4w2">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-181" data-mp="35b5qh8tylgsr" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-182" data-mp="1svs44zg528x">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-183" data-mp="3syx3yfr8jzvm" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-184" data-mp="3k6v68p8jwxp1">
          Price in USD. You&apos;ll be charged the equivalent in your local currency.
        </p>
      </div>
    </section>;
}